module.exports = __webpack_public_path__ + "66c3d7bf.jpg";